import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  right?: ReactNode;
}

function PageHeader({ title, subtitle, right }: PageHeaderProps) {
  return (
    <header className="driver-page-header">
      <div className="driver-page-header__main">
        <h1 className="driver-page-header__title">{title}</h1>
        {subtitle ? <p className="driver-page-header__subtitle">{subtitle}</p> : null}
      </div>
      {right}
    </header>
  );
}

export default PageHeader;
